import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";

const RequireAuth = ({ children }) => {
  const { isAuthenticated, isAdmin, sessionExpired } = useAuth();

  if (!isAuthenticated) return <Navigate to={sessionExpired ? "/admin-login?reason=session-expired" : "/"} replace />;
  if (!isAdmin) return <Navigate to="/" replace />;

  return children;
};

export default RequireAuth;
